<template>
  <v-container>
    <v-toolbar color="primary" dark>
      <v-toolbar-title dark>Интеграции</v-toolbar-title>
      <template v-slot:extension>
        <v-tabs fixed-tabs color="primary" active-class="active-tab">
          <v-tabs-slider color="#FDE700"></v-tabs-slider>
          <v-tab
            ref="vk_groups"
            key="vk_groups"
            :to="{ name: 'vk_groups', params: { site_key: $attrs.site_key } }"
          >
            Группы Вконтакте
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <router-view
      name="integrations"
      :site_key="$attrs.site_key"
      :site_title="$attrs.site_title"
    ></router-view>
  </v-container>
</template>

<script>
export default {
  name: 'VKIndex',
}
</script>
